import * as THREE from 'three';
import layout from './rail-infill-layout.json';

export const RAIL_FLOOR_LAYOUT = layout;

/** Floor-matched strips with guide slots derived from the complete CAD section.
 *  Shared by the full door and the cutaway; no geometry or colour substitutes.
 */
export function makeRailFloorInfill(length, material, floorLevel = 0) {
  const group = new THREE.Group();
  group.name = 'rail-channel-floor-inserts';
  const thickness = layout.thickness_mm / 1000;
  layout.strips.forEach((strip, index) => {
    const width = (strip.end_mm - strip.start_mm) / 1000;
    const center = (strip.start_mm + strip.end_mm) / 2000;
    const mesh = new THREE.Mesh(new THREE.BoxGeometry(length, thickness, width), material);
    mesh.name = `${strip.track}-floor-insert-${index + 1}`;
    mesh.position.set(0, floorLevel - thickness / 2, center);
    mesh.castShadow = true; mesh.receiveShadow = true;
    mesh.userData.track = strip.track;
    group.add(mesh);
  });
  group.visible = false;
  return group;
}